//
//
//
//
//
//
export default {
  name: "wel",
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  methods: {}
};